import AsyncEvent from './AsyncEvent';
import * as utility from './Utility';
import log from 'loglevel';

const msgmap = {};
const pushmap = {};
const PID = 0;


/**
 * publicKey와 suite를 받아 cihperKey, vertifedKey를 반환합니다.
 * 암호화에 사용됩니다.
 * @param {string} publicKey
 * @param {string} cipherSuite 
 * @returns {{cipherKey, verifiedKey}}
*/
 function encryptKeys(publicKey, cipherSuite) {
	var cipherSuiteList = cipherSuite.split("_");
	var cipherKey = null;
	var verifiedKey = null;
	var suite = cipherSuiteList[0];
	var ecObject = ecdhe(suite, publicKey);
	cipherKey = ecObject.cipherKey;
	verifiedKey = ecObject.verifiedKey;

	return { cipherKey: cipherKey, verifiedKey: verifiedKey };
}

function ecdhe(suite, publicKey) {
	var ellipticCurve = elliptic.ec(suite.replace("P-", "p"));
	var keyPair = ellipticCurve.genKeyPair();
	var cipherKey = keyPair.getPublic().encode("hex");
	var serverKey = ellipticCurve.keyFromPublic(publicKey, "hex");
	var verified = keyPair.derive(serverKey.pub).toString(16).padStart(64, '0');
	var ecObject = { cipherKey: cipherKey, verifiedKey: verified };
	return ecObject;
}

class MessageBusService {
	constructor(session) {
		this.session = session;
		// 서비스 자체를 싱글톤으로 바꿀 필요가 있을 듯
		$(Araqne.worker).off('message.msgbus').on('message.msgbus', this._onMessage.bind(this));
	}

	send(method, options, isMeta = false, isPublic = false) {
		return new AsyncEvent((resolve, reject) => {
			let guid = utility.generateType1();
			msgmap[guid] = {
				time: new Date(),
				resolve: resolve,
				reject: reject
			};

			this._send(guid, method, options, isMeta, isPublic);
		});
	}

	_send(guid, method, options, isMeta, isPublic) {
		Araqne.worker.postMessage({
			'guid': guid,
			'cmd': isMeta ? 'metaSend' : 'send',
			'method': method,
			'options': options,
			'pid': PID,
			'isPublic': isPublic
		});
	}

	subscribe(name, ontrap) {
		return new AsyncEvent((resolve, reject) => {
			this.send('org.araqne.msgbus.PushPlugin.subscribe', {
				'callback': name
			})
			.onSuccess((resp) => {
				if(typeof pushmap[name] === 'undefined') {
					pushmap[name] = {};
				}

				pushmap[name][PID] = ontrap;
				resolve(resp);
			});
		});
	}

	unsubscribe(name, ontrap) {
		return new AsyncEvent((resolve, reject) => {
			this.send('org.araqne.msgbus.PushPlugin.unsubscribe', {
				'callback': name
			})
			.onSuccess(resp => {
				if(!!pushmap[name]) {
					// if(!!pushmap[name][PID]) {
					// 	pushmap[name][PID] = null;
					// 	delete pushmap[name][PID];
					// }
					pushmap[name] = null;
					delete pushmap[name];
				}

				resolve(resp);
			});
		})
	}

	_onTrap(resp) {
		var method_name = resp[0].method;

		if(!pushmap.hasOwnProperty(method_name)) {
			return;
		}
		else {
			if(typeof pushmap[method_name][resp[0].target] !== 'function') {
				log.warn('no msgmap fn.\n method_name: ', method_name, '\n resp[0].target:', resp[0].target);
			}
			else {
				pushmap[method_name][resp[0].target](resp[1]);
			}
		}
	}

	_onMessage(e) {
		var data = e.originalEvent.data;
		var guid = data.guid;
		var raw = data.raw[0];
		if(raw.type === 'Response') {
			this._onMessageResponse(data);
		} else if(raw.type === 'Trap') {
			this._onTrap(data.raw);
		} else if (raw.type === 'negotiate-encrypt-keys') {
			var keys = encryptKeys(raw.data.publicKey, raw.data.cipherSuite);
			Araqne.worker.postMessage({
				'cmd': 'encryptKeys',
				'options': keys,
			});
		}
		msgmap[guid] = null;
		delete msgmap[guid];
	}


	_onMessageResponse(data) {
		var resp = data.raw;
		var guid = data.guid;
		var defer = msgmap[guid];
		if(!!defer) {
			if(resp[0].hasOwnProperty('errorCode')) {
				if(resp[0].errorCode == 'wsframelimit') {
					// notify('error', resp[0].errorMessage, false);
					defer.reject(resp[0], resp[1]);
				}
				else {
					defer.reject(resp[0], resp[1]);
				}
			}
			else {
				defer.resolve(resp[1], resp);
			}
		}

	}
}

export default MessageBusService;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/core/MessageBusService.js